import { all } from "ramda";
import { ensureArray } from "ramda-adjunct";

export const isPathString = (path: any): path is string => typeof path === 'string' && !path.includes('/') && !path.includes('.');

export const isPathDot = (path: any) => {
  const result = (typeof path === 'string') && path.includes('.') && !path.includes('/');
  return result;
}

export const isPathArray = (path: string | string[]) => {
  const sub = ensureArray(path);
  const result = all((x: any) => isPathString(x) && !isPathDot(x))(sub);
  return result;
}

export const isPath = (x:any) => isPathArray(x) || isPathString(x) || isPathDot(x);

